import axios from "axios";
import { Config } from "../config";
import { action, observable } from "mobx";
import { lockScroll, unlockScroll } from "../@helpers";

class ChatBot {
  @observable showBot = false;
  @observable showChatbotModal = false;
  @observable messages = [];
  @observable hasBot = false;
  @observable promptState = "user";
  @observable cognitiveLoad = 5000;

  @action
  populate = () => {
    const endpoint = `${Config.endpoint.chatbot.base}${Config.endpoint.chatbot.api}${Config.endpoint.chatbot.event}`;
    axios
      .post(endpoint, {
        event: "Welcome"
      })
      .then(response => {
        console.log(`cDM::success\n$`, response);
        if (response.status === 200) {
          this.hasBot = true;
          const replies = response.data.fulfillmentMessages;
          return replies;
        }
      })
      .then(replies => this.formatReplies(replies)) // format the responses
      .then(replies => this.staggerDisplay(replies)) // stagger the display of the responses
      .catch(error => {
        this.killAlma(error);
      });
  };

  @action
  initChatbotModal = () => {
    const popupViewed =
      localStorage.getItem("chatbot_popup_viewed") === `true` ? true : false;
    console.log(popupViewed, localStorage.getItem("chatbot_popup_viewed"));
    this.showChatbotModal = !popupViewed;
    document.documentElement.style.overflowY = popupViewed ? `` : `hidden`;
  };

  @action
  updateShowBot = newState => {
    this.showBot = newState;
  };

  @action
  updateMessage = message => {
    this.messages = [...this.messages, message];
  };

  @action
  toggleChatbot = () => {
    const isMobile = () => {
      var check = false;
      (function(a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    };
    if (isMobile()) {
      if (this.showBot) {
        unlockScroll();
      } else {
        lockScroll();
      }
    }
    this.showBot = !this.showBot;
  };

  @action
  openChatbot = e => {
    this.showBot = true;
  };

  @action
  closeChatbot = e => {
    if (e) {
      e.preventDefault();
    }
    this.toggleChatbot();
  };

  @action
  closeChatbotModal = e => {
    if (e) {
      e.preventDefault();
    }
    localStorage.setItem("chatbot_popup_viewed", true);
    this.showChatbotModal = false;
    document.documentElement.style.overflowY = ``;
    if (e.currentTarget.dataset.action !== "close") {
      this.openChatbot();
    }
  };

  @action
  killAlma = error => {
    console.error(`kill alma\n$`, error);

    setTimeout(() => {
      this.updateMessage({
        speaks: "system",
        text: `<strong>${Config.message.error.noChatbot}</strong>.<br/>${error}`
      });
      this.promptState = "user";
    }, this.cognitiveLoad);
  };

  @action
  staggerDisplay = replies => {
    const length = replies.length - 1;

    replies.forEach((reply, index) => {
      const timer = this.cognitiveLoad * (index + 1);
      setTimeout(() => {
        this.updateMessage(reply);
        this.promptState = index === length ? "user" : "bot";
      }, timer);
    });
  };

  @action
  handleSubmit = e => {
    e.preventDefault();
    console.clear();
    const inputField = e.target.querySelector("#conversation");

    // Get the user input
    const userInput = inputField.value;

    // Display the user input
    this.printUserMessage({ speaks: "user", text: userInput });

    // Empty the input field
    inputField.value = "";

    this.talkToAlma(userInput);
  };

  @action
  handleQuickReply = e => {
    const userInput = e.target.innerText;
    this.printUserMessage({ speaks: "user", text: userInput });
    this.talkToAlma(userInput);
  };

  @action
  formatReplies = replies => {
    replies = replies.map(reply => {
      return {
        speaks: reply.message === "payload" ? "quickreplies" : "bot",
        text:
          reply.message === "payload"
            ? reply.payload.fields.quick_replies.listValue.values
            : reply.text.text[0]
      };
    });
    return replies;
  };

  printUserMessage = message => {
    this.updateMessage(message);
    this.promptState = "bot";
  };

  talkToAlma = userInput => {
    const endpoint = `${Config.endpoint.chatbot.base}${Config.endpoint.chatbot.api}${Config.endpoint.chatbot.text}`;
    axios
      .post(endpoint, {
        text: userInput
      })
      .then(response => {
        console.log(`cDM::success\n$`, response);
        if (response.status === 200) {
          return response.data.fulfillmentMessages;
        } else {
          const error = response.statusText;
          this.killAlma(error);
        }
      })
      .then(replies => this.formatReplies(replies)) // format the responses
      .then(replies => this.staggerDisplay(replies)) // stagger the display of the responses
      .catch(error => {
        this.killAlma(error);
      });
  };
}
const ChatBotStore = new ChatBot();
export default ChatBotStore;
